import { SaveOutlined } from '@ant-design/icons';
import { Button, Flex, Image, Input, List, Select, Space, Table, Tag, Typography } from "antd";
import { ColumnsType, ColumnType } from 'antd/es/table';
import { observer } from "mobx-react";
import { IShortStudent } from '../../models/student';
import Subjects from '../../models/subjects';
import { IShortTask } from "../../models/ticket";
import TicketTypes from "../../models/ticket-type";
import ShortTaskStore from "../../stores/task/short-task";
import TicketItemStore from "../../stores/ticket/ticket-item";
import { SelectValue } from 'antd/es/select';

const { Option } = Select;

const TaskItem: React.FC<{ item: ShortTaskStore }> = ({ item }) => {

    const handleUpdateAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
        item.updateAnswer(event.target.value);
    }

    const handleSaveAnswer = () => {
        item.saveAnswer();
    }

    return <Flex justify="flex-start" gap="small">
        <Input placeholder="не указан" defaultValue={item.task.answer} onChange={handleUpdateAnswer} />
        <Button icon={<SaveOutlined />} onClick={handleSaveAnswer} />
    </Flex>
}

const TicketItem: React.FC<{ ticket: TicketItemStore, indx: number, students: IShortStudent[], subject: Subjects }> = ({ ticket, indx, students, subject }) => {

    const { Text } = Typography;

    const handleExpand = () => {
        ticket.toggle();
    }

    const handleEdit = () => {
        ticket.rollback();
    }

    const handleAssignStudents = () => {
        ticket.assignStudents();
    }

    const handleSelectStudent = (value: SelectValue) => {
        ticket.selectStudents(value as number[]);
    }

    const getPhotoImages = (photoIds: string[]) => {
        return (photoIds || []).map(id => <Image key={id} width={400} src={ticket.getUrl(id)} />);
    }

    const firstColumnEge = {
        title: '№ в КИМ',
        dataIndex: 'numberInKim',
        key: 'numberInKim',
        align: 'center',
        width: '5%',
        render: (numberInKim) => <Tag color="cyan">{numberInKim.name}</Tag>
    } as ColumnType<IShortTask>;

    const firstColumnThematic = {
        title: '№',
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        width: '5%',
        render: (index) => <Tag color="cyan">{index + 1}</Tag>
    } as ColumnType<IShortTask>;

    const mainColumns: ColumnsType<IShortTask> = [
        {
            title: 'Задача',
            key: 'id',
            align: 'center',
            width: '20%',
            render: (_) => <div>
                <Image.PreviewGroup>{getPhotoImages(_.photoIds)}</Image.PreviewGroup>
                <div style={{ display: "block" }}>
                    <Tag color="purple">{_.id}</Tag>
                    <Button type='link' href={`/${subject.toLowerCase()}/tasks/edit/${_.id}`}>Редактировать</Button>
                </div>
            </div>
        },
        {
            title: 'Ответ',
            key: 'answer',
            width: '20%',
            align: 'center',
            render: (_) => <TaskItem {...{ item: new ShortTaskStore(_) }} />
        },
        {
            title: 'Решение',
            dataIndex: 'solutionPhotoIds',
            key: 'solutionPhotoIds',
            width: '55%',
            align: 'left',
            render: (solutionPhotoIds: string[]) => <div style={{ width: "100%" }}><Image.PreviewGroup>{getPhotoImages(solutionPhotoIds)}</Image.PreviewGroup></div>
        }
    ];

    const egeColumns: ColumnsType<IShortTask> = [firstColumnEge, ...mainColumns];
    const thematicColumns: ColumnsType<IShortTask> = [firstColumnThematic, ...mainColumns];

    return (
        <List.Item key={ticket.data.id}>
            <List.Item.Meta
                title={
                    <Flex justify="flex-start" gap="middle">
                        <Text strong>{indx + 1}. Вариант №{ticket.data.id}{ticket.data.name && ` (${ticket.data.name})`}</Text>
                        <Text>{`${ticket.data.currentTaskCount}/${ticket.data.taskCount}`}</Text>
                        <Tag color={ticket.data.ticketType === TicketTypes.EGE ? "magenta" : "cyan"}>
                            {ticket.data.ticketType === TicketTypes.EGE ? "ЕГЭ" : "Тематический"}
                        </Tag>
                    </Flex>
                }
                description={
                    <Flex align="flex-start" vertical>
                        <Flex justify="center" gap="small">
                            <Button type='link' onClick={handleExpand}>{ticket.expanded ? "Скрыть ответы" : "Открыть ответы"}</Button>
                            <Button type='link' onClick={handleEdit}>Редактировать</Button>
                            {ticket.data.pdf && <Button id={ticket.data.id.toString()} type='link' href={ticket.getUrl(ticket.data.pdf)}>Скачать PDF</Button>}
                            <Space.Compact block>
                                <Select
                                    mode='multiple'
                                    placeholder="ученики"
                                    optionLabelProp="label"
                                    onChange={handleSelectStudent}
                                    style={{ paddingLeft: "15px", width: "20em" }}
                                    value={ticket.selectedStudents}
                                >
                                    {students?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
                                </Select>
                                <Button onClick={handleAssignStudents}>Назначить</Button>
                            </Space.Compact>
                        </Flex>
                    </Flex>
                }
            />
            {ticket.expanded &&
                <Table columns={ticket.data.ticketType === TicketTypes.EGE ? egeColumns : thematicColumns}
                    dataSource={ticket.enumerateTasks()}
                    pagination={false} style={{ marginTop: "15px", minWidth: "100%" }} bordered />
            }
        </List.Item>
    );
};

export default observer(TicketItem);